import TooptipComponent from './Tooltip.component';

export default TooptipComponent;
